import { isEmployerSponsored } from "../utils/isEmployerSponsored";
import mapKnownValues from "../utils/mapKnownValues";

export enum TransferAccountType {
  EMPLOYER_401k = "401k",
  EMPLOYER_403b = "403b",
  EMPLOYER_457 = "457",
  IRA = "IRA",
  ROTH_IRA = "ROTH_IRA",
  SIMPLE_IRA = "SIMPLE_IRA",
  SEP_IRA = "SEP_IRA",
}

export enum AcceptsRothFundsResponse {
  YES = "YES",
  NO = "NO",
}

export type UserOtherAccount = {
  accountNumber: string;
  accountType: string;
  created: string;
  providerName: string | null;
};

export enum MartialStatusResponse {
  YES = "YES",
  NO = "NO",
}

export type UserResponse = {
  userId?: string;
  clientUserId: string; // REQUIRED
  created?: string | null;
  email: string; // REQUIRED
  phoneNumber?: string;
  firstName: string; // REQUIRED
  middleName?: string;
  lastName: string; // REQUIRED
  suffix?: string;
  citizenship?: string;
  dateOfBirth?: string;
  married?: MartialStatusResponse;
  address?: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
};

export type TransferIntentResponse = {
  transferIntentId: string;
  status: string;
  created: string;
  mode: string;
  transferAccount: {
    accountNumber?: string;
    accountType: TransferAccountType; // REQUIRED
    created?: string;
    acceptsRothFunds: AcceptsRothFundsResponse; // REQUIRED
    planName?: string;
    planNumber?: string;
    providerName: string; // REQUIRED
    planSponsor?: string;
  };
  accounts: Array<UserOtherAccount>;
  user: UserResponse;
};

export class TransferIntent {
  transferIntentId = "";
  status = "";
  mode = "";
  transferAccount: TransferIntentResponse["transferAccount"] | undefined = undefined;
  accounts: Array<UserOtherAccount> = [];
  user: TransferIntentResponse["user"] | undefined = undefined;
  isEmployerSponsored = false;

  constructor(response: TransferIntentResponse) {
    mapKnownValues(this, response);
    this.isEmployerSponsored = isEmployerSponsored(response.transferAccount.accountType);
  }
}
